export default "__VITE_ASSET__BzpcHVWQ__"